<template>
<div>
<querytitle>
  <template slot="queryleft">
    <div>模糊查找：</div>
    <div><el-input v-model="querykey" size="mini"></el-input></div>
    <div><el-button type="primary" size="mini" @click="getlist()">查找</el-button></div>
  </template>
  <template slot="queryright">
    <el-button type="primary" size="mini" @click="add()">新增</el-button>
  </template>
</querytitle>
<el-table :data="itemlist" border style="width:100%" :height="hh" stripe size="mini">
  <el-table-column prop="srid" label="角色编号" width="100"></el-table-column>
  <el-table-column prop="srname" label="角色名称" width="150"></el-table-column>
  <el-table-column prop="srlevels" label="角色权限"></el-table-column>
  <el-table-column fixed="right" label="操作" width="150">
    <template slot-scope="scope">
     <el-button @click="edit(scope)" type="primary" size="mini">编辑</el-button>
      <el-button type="danger" size="mini" @click="del(scope)">删除</el-button>
    </template>
  </el-table-column>
</el-table>
<el-pagination style="text-align:left;" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40, 200]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="rt">
</el-pagination>
<el-dialog title="角色信息" :visible="dialogFormVisible" :show-close="false" width="80%" @opened="show">
<el-form label-width="100px">
    <el-row>
        <el-col :span="12">
  <el-form-item label="角色编号">
    <el-input v-model="itemedit.srid" @input="inputmethod()"></el-input>
  </el-form-item>
        </el-col>
        <el-col :span="12">
  <el-form-item label="角色名称">
    <el-input v-model="itemedit.srname" @input="inputmethod()"></el-input>
  </el-form-item>
        </el-col>
    </el-row>
  <el-table ref="multipleTable" :data="menus" tooltip-effect="dark" style="width: 100%" :height="hh-300" @selection-change="handleSelectionChange">
    <el-table-column type="selection" width="55"></el-table-column>
    <el-table-column label="功能名称" prop="name" width="180"></el-table-column>
    <el-table-column prop="path" label="地址" show-overflow-tooltip></el-table-column>
  </el-table>
</el-form>
<div slot="footer" class="dialog-footer">
 <el-button @click="dialogFormVisible=false">取 消</el-button>
 <el-button type="primary" @click="postdata()">确 定</el-button>
</div>

</el-dialog>
</div>
</template>
<script>
import querytitle from '@/components/querytitle'
export default {
components: {
  querytitle
},
data() {
  return {
    hh: 500,
    loading:false,
    addflag: false,
    itemlist: [],
    itemindex: 0,
    itemedit: {},
    dialogFormVisible: false,
    rt: 0,
    currentPage: 1,
    pagesize: 10,
    pars:{objname:'sys_roles'},
    querykey:"",
    menus:[],
    multipleSelection:[]
  };
},
created() {
    let tmpmenus = this.$router.options.routes[2].children;
    tmpmenus.splice(0,1)
    this.menus = []
    tmpmenus.forEach(item=>{
        this.menus.push({name:item.name,path:item.path})
    })
    this.hh = document.documentElement.clientHeight - 220;
    this.getlist();
},
methods: {
  handleSelectionChange(val) {
    this.multipleSelection = val;
  },
  add() {
    this.addflag = true;
    this.itemedit.srid = "";
    this.multipleSelection = [];
    this.dialogFormVisible = true;
    
  },
  show(){
    if(this.addflag)
        this.$refs.multipleTable.clearSelection();
    else{
        let selectedmenus = []
        try{
            selectedmenus = JSON.parse(this.itemedit.srlevels)
        }catch{
            selectedmenus=[]
        }
        let that =this
        that.menus.forEach(row=>{
            if(selectedmenus.findIndex(item=>item.path==row.path)>=0)
                that.$refs.multipleTable.toggleRowSelection(row,true);
            else
                that.$refs.multipleTable.toggleRowSelection(row,false);
        })
        // for(var i=0;i<that.menus.length;i++){
        //     for(var j=0;j<selectedmenus.length;j++){
        //         if(that.menus[i].name === selectedmenus[j].name){
        //             that.$refs.multipleTable.toggleRowSelection(that.menus[i],true);
        //             break;
        //         }
        //     }
        // }
    }
  },
  edit(par) {
    this.addflag = false;
    this.itemindex = par.$index;
    this.itemedit = Object.assign({}, par.row);
    
    
    
    this.dialogFormVisible = true;

    // let that =this
    // selectedmenus.forEach(row=>{
    //     that.$refs.multipleTable.toggleRowSelection(row,true);
    // })
    
  },
  del: function (par) {
    let that = this;
    that.$confirm("确定要删除当前行吗？", "询问", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
    }).then(() => {
        var pars = {objname: "sys_roles",model: par.row};
        that.PostData("Common/DEL",pars,function (res) {
            if (res.data.error_code != 0) {
             that.$alert(res.data.message, {title: "错误"});
             return;
             }
             that.itemlist.splice(par.$index, 1);
          },function (err) {
            that.$alert(err, {title: "错误",type: 'error'});
          }
        );
      })
      .catch(() => {});
    },
    postdata() {
      let that = this;
      if (!that.itemedit.srid) {
        that.$alert("角色编号不能为空", {title: "提示"});return;
      }
      if (!that.itemedit.srname) {
        that.$alert("角色名称不能为空", {title: "提示"});return;
      }
      that.itemedit.srlevels = JSON.stringify(this.multipleSelection)
      let pars = {objname: "sys_roles",model: Object.assign({}, that.itemedit)};
      if (that.addflag) {
          that.PostData("Common/ADD",pars,function (res) {
            if (res.data.error_code != 0) {
              that.$alert(res.data.message, {title: "错误"});return;
            }
            that.itemlist.push(pars.model);
            that.dialogFormVisible = false;
          },function (err) {that.$alert(err, {title: "错误",type: 'error'});}
        );
      } else {
        that.PostData("Common/EDIT",pars,function (res) {
          if (res.data.error_code != 0) {
            that.$alert(res.data.message, {title: "错误"});return;
          }
            that.$set(that.itemlist, that.itemindex, pars.model);
            that.dialogFormVisible = false;
          },function (err) {that.$alert(err, {title: "错误",type: 'error'});}
        );
      }
    },
    getlist() {
        let that = this
        let wherestring = []
        if(this.querykey){
          wherestring = [{field: 'srname',sym: 'like',val: this.querykey,oper: ''},]
        }
        let pars = {objname: "sys_roles",wheres: wherestring,PageSize: that.pagesize,CurrentPage: that.currentPage}
        that.PostData("Common/GETLIST", pars,function (res) {
          that.itemlist = res.data.data;
          that.rt = res.data.rowTotal
        },function (err) {
          that.$alert(err, {title: "错误"});
        }
      );
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.getlist()
    },
    handleSizeChange(e) {
      this.pagesize = e;
      this.getlist()
    },
  }
};
</script>
